import { FAQs as FAQS } from "@ecologi/react-components/src/FAQs";
import { useRouter } from "next/router";

export default function FAQs(props: any) {
  const router = useRouter();
  return <FAQS {...props} slug={router?.query?.slug} />;
}
